import { React, useEffect, useState } from "react";
import { collectionsDictionary } from "../../../../helpers/netWorking/Constants";
import Search from "./search/Search.js";
import "./collections.css";
import { CollectionService } from "./../../../../services/collections/CollectionService";
import { CustomNotification } from "../../../../components/customNotification/customNotification";

export default function Collections({ newImage }) {

  const [SelectedCollection, setSelectedCollection] = useState("4001 Project");
  const [notificaciones, setNotificaciones] = useState([])


  const [TokenID, setTokenID] = useState("")
  const [imgUrl, setImgUrl] = useState("")
  const [exoPlanetName, setExoPlanetName] = useState("")
  const [ImageExist, setImageExist] = useState(false)

  const CollectionServiceHandler = async () => {
    try {
      setImageExist(false)
      let image = await fetch(`https://api${collectionsDictionary[SelectedCollection]}.the4001project.com/tokens/${TokenID}`);
      let urlImg = await image.json();

      let r = urlImg.data.os_image_url;
      if (r == null) throw new Error('image does not exists!');
      setExoPlanetName(urlImg.data.name)
      setImgUrl(r);
      setImageExist(true)
    } catch {
      setImageExist(false)
    }

  }
  useEffect(() => {

    if (TokenID)
      CollectionServiceHandler()

  }, [TokenID, SelectedCollection])

  const addexoplanet4001Handler = () => {

    setNotificaciones(elem => {
      let nuevo = [...elem, <CustomNotification text={'Exoplanet added!'} key={elem.length} />]
      return nuevo
    });
    newImage(`${imgUrl}`, true)
  }
  return (
    <>
      <Search SelectedCollection={SelectedCollection} TokenID={TokenID} setSelectedCollection={setSelectedCollection} setTokenID={setTokenID} />

      {(ImageExist && TokenID) ?
        <div className="exoplanet4001Card" onClick={addexoplanet4001Handler}>
          <img src={`${imgUrl}`} />
          <div className="exoplanet4001Name">
            The {exoPlanetName}
          </div>
          <div className="exoplanet4001Add">
            {
              (window.innerWidth < 780) ? "Tap" : "Click"
            } to Add
          </div>
        </div> :
        <div className="exoplanet4001Warning">
          {TokenID ? ` Try to apply transit method, the wobble method or another token ID.` : "Discover an Exoplanet."}
        </div>
      }

      {
        notificaciones.map((notif) => {
          return notif
        })
      }
    </>
  );
}
